import { render, staticRenderFns } from "./WhiteboardDrawer.vue?vue&type=template&id=2ab1a95e&scoped=true&"
import script from "./WhiteboardDrawer.vue?vue&type=script&lang=js&"
export * from "./WhiteboardDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1a95e",
  null
  
)

export default component.exports